<input type="file" #fileInput style="display:none" (change)="onFileSelected($event)">
<eazly-modal-window class="modal-dialog">
    <div modalWindowHeader>
        <div class="modal-title" i18n="@@ImportPhotoWindowTitle">
            Photo import wizard
        </div>
        <div class="errors">
            <div *ngIf="hasErrors() && loadingFinished" class="global-error-message" i18n='@@FieldsErrorMsg'>The
                Artificial Intelligence service has not recognized some fields, you can manually correct the errors.
            </div>
        </div>
    </div>
    <div modalWindowBody *ngIf="!loadingFinished" i18n="@@PhotoLoadingTitle">
        <div>
            Photo processing in progress by the Artificial Intelligence service, please wait.
        </div>
        <div class="spinner-message">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
        </div>
    </div>
    <div modalWindowBody *ngIf="loadingFinished">
        <div id="canSelectionMsg" i18n='@@canSelectionMsg'>Please choose the fields you want to import!</div>
        <form #form="ngForm">
            <div *ngFor="let item of newData; let i = index;">
                <div class="form-group"
                    [ngStyle]="{'border' : !shouldBeGrayedOut[i]  ? '1px solid orange' : '1px solid #ccc'}">
                    <div class="flex-container">
                        <div class="label-input-group">
                            <ng-container *ngIf="item.type == '' && item.name == '';else write_label">
                                <input class="input" value="select a label" name="checkbox{{i}}" type="text"
                                    [ngStyle]="{'opacity': shouldBeGrayedOut[i] ? '0.5' : '1'}"
                                    (change)="onLabelTextChange($event,i)" />
                            </ng-container>
                            <ng-template #write_label>
                                <span class="input" value="{{item.name}}" name="checkbox{{i}}" type="text"
                                    [ngStyle]="{'opacity': shouldBeGrayedOut[i] ? '0.5' : '1'}"
                                    (input)="onLabelTextChange($event,i)" contenteditable="true">{{item.name}}</span>
                            </ng-template>
                            <div class="dropdown" [ngStyle]="{'opacity': shouldBeGrayedOut[i] ? '0.5' : '1'}">
                                <div class="dropdown-btn"
                                    [ngStyle]="{'border': hasError(i) ? '0.5mm solid red' : '0.5mm solid #ccc'}"
                                    (click)="checkDropdown(i)" (keypress)="onPress($event)"
                                    (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)">
                                    <ng-container *ngIf="! dropdownStates[i].selectedAsset">
                                        <ng-container *ngIf="item.type == 'text_input';else liste">
                                            {{addTextAsset(i)}}
                                            <img id='TEXT_FIELD' src="assets/icons/champ_texte_input.svg"
                                                title="Champ de type texte" alt="Champ de type texte">
                                        </ng-container>
                                        <ng-template #liste>
                                            <ng-container *ngIf="item.type == 'liste';else boutton_radio">
                                                {{addChoiceAsset(i)}}
                                                <img id='COMBO_BOX' src="assets/icons/combobox_input.svg"
                                                    title="Liste de valeur" alt="Liste de valeur">
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #boutton_radio>
                                            <ng-container
                                                *ngIf="item.type == 'button_radio_selected' || item.type == 'button_radio_no_selected';else button_submit">
                                                {{addRadioAsset(i)}}
                                                <img id='RADIO_BUTTON' src="assets/icons/radio_input.svg"
                                                    title="Bouton radio" alt="Bouton radio">
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #button_submit>
                                            <ng-container *ngIf="item.type == 'submit_button'; else error"
                                                i18n="@@AssetSelectionTitle">Select
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #error>
                                            <ng-container *ngIf="item.error_type || item.error_field"
                                                i18n="@@AssetSelectionTitle">Select</ng-container>
                                        </ng-template>

                                    </ng-container>
                                    <ng-container *ngIf="dropdownStates[i].selectedAsset">
                                        <img [src]="dropdownStates[i].selectedAsset.iconWizard"
                                            alt="{{dropdownStates[i].selectedAsset.name}}"
                                            style="width: 20mm; height: auto;">
                                    </ng-container>
                                </div>
                                <div *ngIf="dropdownStates[i].isOpen" class="dropdown-content">
                                    <div *ngFor="let asset of assets">
                                        <div *ngIf="asset.category == 'Input' || asset.category == 'Choice'"
                                            (click)="selectAsset(i,asset)" class="dropdown-item"
                                            (keypress)="onPress($event)" (keydown)="onKeyDown($event)"
                                            (keyup)="onKeyUp($event)">
                                            <a class="list-group-item">
                                                <img [src]="asset.iconWizard" alt="{{asset.name}}"
                                                    class="palette-item-icon">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hover-container">
                            <img id="loop" src="assets/icons/magnifier.svg" alt="loop" class="loop-icon">
                            <img [src]="trustBase64(item.image)" class="hover-image" alt="Hover" />
                        </div>
                        <input type="checkbox" id="checkbox{{i}}" [name]="'checkbox' + i"
                            [checked]="initcheckboxState(i)" (change)="changeCheckboxState(i,$event)"
                            title="import field">
                    </div>
                    <ng-container *ngIf="item.type == 'submit_button'">
                        {{showError(i)}}
                        <div [hidden]="!showSubmitButtonErrorMessage[i]" class="error-message" i18n='@@TypeErrorMsg'>
                            The shape is not recognized, please select a field type.</div>
                    </ng-container>
                    <ng-container *ngIf="item.error_field ;else error_type ">
                        {{showImportFieldError(i)}}
                        <div *ngFor="let element of item.error_field">
                            <div [hidden]="!showImportFieldErrorMessage[i]" class="error-message"
                                i18n='@@FieldErrorMsg'>
                                The whole field is not recognized, please select a field type.</div>
                        </div>
                    </ng-container>
                    <ng-template #error_type>
                        <ng-container *ngIf="item.error_type">
                            {{showImportTypeError(i)}}
                            <div *ngFor=" let element of item.error_type;let j = index">
                                <div [hidden]="!showImportTypeErrorMessage[i]" class="error-message"
                                    i18n='@@TypeErrorMsg'>The shape is not recognized, please select a field type.</div>
                            </div>
                        </ng-container>
                    </ng-template>
                </div>
            </div>
        </form>
    </div>
    <div modalWindowFooter>
        <button (click)=" hide()" id="CancelModalWindow" type="button" class="btn eazlybtn btn-lg" i18n="@@Cancel">
            <i class="fas fa-arrow-left"></i>
            Cancel
        </button>

        <button id="ImportModalWindow" (click)="onSubmit(newData)" type="submit" form="visibilityForm"
            class="btn eazlybtn btn-lg" i18n="@@ImportModalWindow" [disabled]="isButtonDisabled"
            *ngIf="loadingFinished">
            <i class="fas fa-check"></i>
            Import
        </button>
    </div>
    <eazly-navigator [myappeaz]="appeaz" [steps]="intersectionStep">
    </eazly-navigator>
</eazly-modal-window>
